import { createApp, h } from 'vue'
import { InertiaProgress } from '@inertiajs/progress'
import { createInertiaApp, router } from '@inertiajs/inertia-vue3'
import { SetupCalendar, Calendar, DatePicker } from 'v-calendar'
import moment from 'moment'

InertiaProgress.init({
    // The delay after which the progress bar will
    // appear during navigation, in milliseconds.
    delay: 350,

    // The color of the progress bar.
    color: '#29d',

    // Whether to include the default NProgress styles.
    includeCSS: false, //this

    // Whether the NProgress spinner will be shown.
    showSpinner: true,
})

moment.locale('de-at')


createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  title: title => title ? `${title} - ORF-E Office Tool` : 'ORF-E Office Tool',
  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(App, props) })
        .use(SetupCalendar, {})
        .component('Calendar', Calendar)
        .component('DatePicker', DatePicker)
        .use(plugin)
        .mount(el)
  },

})
